import React, { useState } from 'react';
import GlobalDialog from '../../../../mui/Dialogue/GlobalDialog';
import { Button } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Profile } from '../../../CRM/AdmissionRegister/StudentProfile/Profile';

const ProfileViewAdmissionRegister = ({ admNo }) => {
  return <Profile admNo={admNo} />;
};

export default ProfileViewAdmissionRegister;
